// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { ListArchiveTypeEx_abstract } from './../abstract/SagaBase/ListArchiveTypeEx_abstract';
export class ListArchiveTypeEx extends ListArchiveTypeEx_abstract {}
